import { render, staticRenderFns } from "./SocialTabs.vue?vue&type=template&id=2e989941&"
import script from "./SocialTabs.vue?vue&type=script&lang=js&"
export * from "./SocialTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e989941')) {
      api.createRecord('2e989941', component.options)
    } else {
      api.reload('2e989941', component.options)
    }
    module.hot.accept("./SocialTabs.vue?vue&type=template&id=2e989941&", function () {
      api.rerender('2e989941', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/SocialTabs.vue"
export default component.exports